export default {
      id: "md_stop-usage",
      viewBox: "0 0 13 15",
      url: __webpack_public_path__ + "img/icons.svg#md_stop",
      toString: function () {
        return this.url;
      }
    }